import SlideshowRoundedIcon from '@mui/icons-material/SlideshowRounded';
import { Box, Button, Tooltip } from '@mui/material';
import React from 'react';

interface Props {
  exportIsLoading: boolean;
  onExport: () => void;
}

const StudyReportWorkspaceHeaderCard = React.forwardRef<HTMLDivElement, Props>(({ exportIsLoading, onExport }, ref) => {
  return (
    <Box
      ref={ref}
      data-testid="study-report-workspace-header"
      sx={{
        width: '100%',
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'flex-end',
      }}
    >
      <Tooltip title="Export to PowerPoint">
        <Button
          variant="outlined"
          size="small"
          startIcon={<SlideshowRoundedIcon />}
          disabled={exportIsLoading}
          onClick={onExport}
          aria-label="Export to PowerPoint"
          sx={{ whiteSpace: 'nowrap', flexShrink: 0 }}
        >
          {exportIsLoading ? 'Exporting PPTX...' : 'Export PPTX'}
        </Button>
      </Tooltip>
    </Box>
  );
});

StudyReportWorkspaceHeaderCard.displayName = 'StudyReportWorkspaceHeaderCard';

export default StudyReportWorkspaceHeaderCard;
